/* eslint-disable import/no-anonymous-default-export */
import axios from 'axios';

const APIs = {
  AUTH: '/auth',
  LOGIN: '/auth/login',
  LOGOUT: '/auth/logout',
  USERS: '/users',
  DRIVERS: '/drivers',
  CUSTOMERS: '/customers',
};

async function login(values: any) {
  const { data } = await axios.post(APIs.LOGIN, values);
  return data;
}

async function logout() {
  const { data } = await axios.put(APIs.LOGOUT);
  return data;
}

async function me() {
  const { data } = await axios.get(`${APIs.AUTH}/me`);
  return data;
}

async function updateMe(values: any) {
  const { data } = await axios.put(`${APIs.AUTH}/me`, values);
  return data;
}

async function getMyIP() {
  const { data } = await axios.get(`${APIs.USERS}/myip`);
  return data;
}

async function getUsers(params: any) {
  const { data } = await axios.get(APIs.USERS, { params });
  return data;
}

async function addUser(values: any) {
  const { data } = await axios.post(APIs.USERS, values);
  return data;
}

async function updateUser(values: any) {
  const { data } = await axios.put(APIs.USERS, values);
  return data;
}

async function resetPassword(id: number) {
  const { data } = await axios.put(`${APIs.USERS}/${id}/reset-password`);
  return data;
}

async function getDrivers(params: any) {
  const { data } = await axios.get(APIs.DRIVERS, { params });
  return data;
}

async function addDriver(values: any) {
  const { data } = await axios.post(APIs.DRIVERS, values);
  return data;
}

async function updateDriver(values: any) {
  const { data } = await axios.put(APIs.DRIVERS, values);
  return data;
}

async function resignDriver(id: number) {
  const { data } = await axios.put(`${APIs.DRIVERS}/${id}/resign`);
  return data;
}

async function driverOff(values: any) {
  const { data } = await axios.put(`${APIs.DRIVERS}/off`, values);
  return data;
}

async function getDriverSchedules(params: any) {
  const { data } = await axios.get(`${APIs.DRIVERS}/schedules`, { params });
  return data;
}

async function updateDriverSchedule(values: any) {
  const { data } = await axios.put(`${APIs.DRIVERS}/schedules`, values);
  return data;
}

async function getDriverOrders(params: any) {
  const { data } = await axios.get(`${APIs.DRIVERS}/orders`, { params });
  return data;
}

async function getDriverOrder(id: string) {
  const { data } = await axios.get(`${APIs.DRIVERS}/orders/${id}`);
  return data;
}

async function addDriverOrder(values: any) {
  const { data } = await axios.post(`${APIs.DRIVERS}/orders`, values);
  return data;
}

async function cancelDriverOrder(id: number) {
  const { data } = await axios.delete(`${APIs.DRIVERS}/orders/${id}`);
  return data;
}

async function getCustomers(params: any) {
  const { data } = await axios.get(APIs.CUSTOMERS, { params });
  return data;
}

async function getCustomerOrders(params: any) {
  const { data } = await axios.get(`${APIs.CUSTOMERS}/orders`, { params });
  return data;
}

async function addCustomerOrder(values: any) {
  const { data } = await axios.post(`${APIs.CUSTOMERS}/orders`, values);
  return data;
}

async function cancelCustomerOrder(id: number) {
  const { data } = await axios.delete(`${APIs.CUSTOMERS}/orders/${id}`);
  return data;
}

async function getTransports(params: any) {
  const { data } = await axios.get(`${APIs.CUSTOMERS}/transports`, { params });
  return data;
}

async function addTransport(values: any) {
  const { data } = await axios.post(`${APIs.CUSTOMERS}/transports`, values);
  return data;
}

async function cancelTransport(id: number) {
  const { data } = await axios.delete(`${APIs.CUSTOMERS}/transports/${id}`);
  return data;
}

async function checkInTransport(id: number) {
  const { data } = await axios.put(`${APIs.CUSTOMERS}/transports/${id}/check-in`);
  return data;
}

async function checkOutTransport(id: number) {
  const { data } = await axios.put(`${APIs.CUSTOMERS}/transports/${id}/check-out`);
  return data;
}

async function getDriverPrice() {
  const { data } = await axios.get(`${APIs.DRIVERS}/prices`);
  return data;
}

async function updateDriverPrice(values: any) {
  const { data } = await axios.put(`${APIs.DRIVERS}/prices`, values);
  return data;
}

async function addPromotionPrice(values: any) {
  const { data } = await axios.post(`${APIs.DRIVERS}/promotion-prices`, values);
  return data;
}

async function getPromotionPriceHistory(params: any) {
  const { data } = await axios.get(`${APIs.DRIVERS}/promotion-prices`, { params });
  return data;
}

export default {
  login,
  logout,
  me,
  updateMe,
  getMyIP,
  getUsers,
  addUser,
  updateUser,
  resetPassword,

  getDrivers,
  addDriver,
  updateDriver,
  resignDriver,
  driverOff,

  getDriverSchedules,
  updateDriverSchedule,
  getDriverOrders,
  addDriverOrder,
  cancelDriverOrder,
  getDriverOrder,

  getCustomers,
  getCustomerOrders,
  addCustomerOrder,
  cancelCustomerOrder,

  getTransports,
  addTransport,
  cancelTransport,
  checkInTransport,
  checkOutTransport,

  getDriverPrice,
  updateDriverPrice,

  addPromotionPrice,
  getPromotionPriceHistory,
};
